import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

function LabelsModal({showLabelsModal, setShowLabelsModal, columns, setColumns}) {

    const [labels, setLabels] = useState([])

    useEffect(() => {
        if(labels.length === 0){
            const l = columns.map(each =>{ return {...each, checked:true}})
            setLabels(l)
        }
    }, [columns])
    
    useEffect(() => {
        const l = labels.filter(each => each.checked)
        setColumns(l)
    },[labels])

    const onChangeCheckbox = (e,eachColumn) => {
        if(e.target.checked){
            const l = labels.map(each => {
                if(each.accessor === eachColumn.accessor){
                    return {...each,checked:true}
                }else{
                    return each
                }
            })
            setLabels(l)
            // let c = [...columns,eachColumn]
            // c = c.filter(each => each.accessor !== "Action")
            // c.push({
            //     "Header": "Action",
            //     "accessor": "Action"
            // })
            // setColumns(c)
        }else{
            const l = labels.map(each => {
                if(each.accessor === eachColumn.accessor){
                    return {...each,checked:false}
                }else{
                    return each
                }
            })
            setLabels(l)
            // const c = columns.filter((each) => each.accessor !== eachColumn.accessor)
            // setColumns(c)
        }
    }
    console.log("labelfiels",labels,columns)
  return (
    <Modal size="md" show={showLabelsModal} onHide={() => { setShowLabelsModal(!showLabelsModal) }}  scrollable>
            <Modal.Header closeButton>
                <Modal.Title> <p style={{padding:0, margin:0, color:"#333333", fontFamily:["Helvetica", "sans-serif"], fontSize:"20px"}}>Select Fields</p></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {labels.map((eachColumn,i) => {
                        if(eachColumn?.Header.includes("Term")){
                            return (
                                <div key={i} className='d-flex align-items-center'>
                                    <input style={{cursor:"pointer"}} className='mr-1' checked={eachColumn.checked} type="checkbox" id={eachColumn?.Header} name={eachColumn?.Header} value={eachColumn?.accessor} onChange={(e) => {onChangeCheckbox(e,eachColumn)}}/>
                                    <label style={{cursor:"pointer"}} className='m-0' htmlFor={eachColumn?.Header}>{eachColumn.Header}</label>
                                </div>
                            )
                        }
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShowLabelsModal(false) }}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
  )
}

export default LabelsModal